// @configs
import routes from "@configs/routes";

// mui
import { Avatar, Box, Typography } from "@mui/material";

// @components
import { Link } from "@components/Link";

interface Props {
  company: {
    name: string
    slug: string
    logo: string | null
  }
}

export default function DeveloperBadge({ company }: Props) {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 5,
    }}>
      {company.logo ? (
        <Box>
          <Avatar
            src={company.logo || ''}
            alt={company.name}
            sx={{
              width: 40,
              height: 40,
            }} />
        </Box>
      ) : ''}
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
      }}>
        <Link variant="subtitle1" href={routes.DEVELOPERS.DETAIL.replace('[slug]', company.slug)}>
          {company.name}
        </Link>
      </Box>
    </Box>
  )
}